import { render } from "./PaymentOption.vue?vue&type=template&id=ba2cb674&scoped=true"
import script from "./PaymentOption.vue?vue&type=script&lang=js"
export * from "./PaymentOption.vue?vue&type=script&lang=js"

import "./PaymentOption.vue?vue&type=style&index=0&id=ba2cb674&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba2cb674"]])

export default __exports__